export class Identificacion {
    public Tipo?: string;
    public Numero?: string;
}
